import {useEffect, useState} from 'react'
import {sanityClient} from './client'
import {siteSettingsQuery} from './queries'

export function useSiteSettings() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    sanityClient
      .fetch(siteSettingsQuery)
      .then((res) => {
        if (!cancelled) {
          setData(res || null)
          setLoading(false)
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err)
          setLoading(false)
        }
      })
    return () => {
      cancelled = true
    }
  }, [])

  return {data, loading, error}
}
